import React, { FC } from 'react'

import { Script } from 'gatsby'

import PageHead from '../../components/PageHead'
import withApp from '../../components/withApp/withApp'

const GOOD_GROWTH_SCRIPT_URL =
  'https://tag.getamigo.io/js/b691197e35c2619a8d2ba651f6bf2821749e7e5c00c20c3e7ef9b88e690a32da/load.js'

const Broadband: FC = () => (
  <Script
    src={GOOD_GROWTH_SCRIPT_URL}
    strategy="post-hydrate"
    data-testid="broadband-amigo-script"
  />
)

export default withApp(Broadband)

export const Head = ({ location }: { location: { pathname: string } }) => (
  <PageHead
    title="Broadband deals"
    description="SMARTY is a new SIM-only mobile network that's built to be fair, transparent and smart."
    location={location}
  >
    <meta name="robots" content="noindex, nofollow" />
  </PageHead>
)
